module.exports = __webpack_public_path__ + "img/hookah.cf1f2010.svg";